module.exports = __webpack_public_path__ + "static/media/upload.3c3414b7.svg";